import React from 'react';
import { Typography, Button, Modal, TextField } from '@scale/scaleui';
import apiFetch from 'react-scale/lib/api-fetch';
import PDFView from 'react-scale/components/scalers/tasks/textcollection/PDFView';

interface TaskerScreeningInstructionsModalProps {
  open: boolean;
  onClose: () => void;
  workerSkillId?: string;
  workerSkillDimension?: string;
  workerSkillName?: string;
  updatingInstructions?: boolean;
  title?: string;
  instructionsUrl?: string;
  setInstructionsUrl?: (url: string) => void;
}

export const TaskerScreeningInstructionsContents: React.FC<
  TaskerScreeningInstructionsModalProps
> = ({
  onClose,
  updatingInstructions,
  workerSkillId,
  workerSkillDimension,
  workerSkillName,
  instructionsUrl,
  setInstructionsUrl,
}) => {
  const handlePublishInstructions = async () => {
    await apiFetch(null, 'corp-api/qualification/update-instruction', {
      method: 'POST',
      body: {
        workerSkillId,
        workerSkillDimension,
        instructionsUrl,
      },
    });
    onClose();
  };

  return (
    <div className="scale-ui scale-theme scale-tailwind">
      <Typography.H4>
        {workerSkillName} - {workerSkillDimension}
      </Typography.H4>
      {updatingInstructions && (
        <div className="mt-4">
          <p>Use this tool to update the auditing instructions for this worker skill.</p>
          <p>
            {' '}
            You can use{' '}
            <a
              href="https://dashboard.scale.com/corp/v2/upload_files_to_s3"
              target="_blank"
              rel="noopener noreferrer"
            >
              this corp tool
            </a>{' '}
            to get a public URL link to a PDF file.
          </p>
          <div className="mt-4">
            <TextField
              id="upload"
              type="text"
              value={instructionsUrl}
              placeholder="Instructions PDF URL"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (setInstructionsUrl) setInstructionsUrl(e.target.value);
              }}
            />
          </div>
        </div>
      )}
      {instructionsUrl && (
        <div className="mt-4">
          <PDFView src={instructionsUrl} renderWithPDFJs dontRenderDownload />
        </div>
      )}
      <div className="flex flex-row">
        {instructionsUrl && (
          <Button
            className="mt-4 mr-4"
            variant="secondary"
            onClick={() => window.open(instructionsUrl)}
          >
            Download Instructions
          </Button>
        )}
        {updatingInstructions && (
          <Button
            className="mt-4"
            variant="primary"
            onClick={handlePublishInstructions}
            disabled={!instructionsUrl}
          >
            Publish Instructions
          </Button>
        )}
      </div>
    </div>
  );
};

const TaskerScreeningInstructionsModal: React.FC<TaskerScreeningInstructionsModalProps> = ({
  open,
  onClose,
  updatingInstructions,
  workerSkillId,
  workerSkillDimension,
  workerSkillName,
  title = 'Skill Instructions',
  instructionsUrl,
  setInstructionsUrl,
}) => {
  return (
    <Modal open={open} onClose={onClose} theme="scale-theme" title={title}>
      <TaskerScreeningInstructionsContents
        open={open}
        onClose={onClose}
        updatingInstructions={updatingInstructions}
        workerSkillId={workerSkillId}
        workerSkillDimension={workerSkillDimension}
        workerSkillName={workerSkillName}
        title={title}
        instructionsUrl={instructionsUrl}
        setInstructionsUrl={setInstructionsUrl}
      />
    </Modal>
  );
};

export default TaskerScreeningInstructionsModal;
